import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NotificationService } from '@shared/services/notificacion/notification.service';

/**
 * Guard que protege la ruta de confirmación de transferencia de propiedad.
 *
 * Verifica que la URL contenga el query param `?token=` antes de activar la ruta.
 * Si falta, redirige a `/inicio` con una notificación informativa.
 *
 * Este guard es una validación puramente local (sin HTTP): solo asegura que el
 * usuario llegó al enlace desde el correo electrónico y no por navegación directa.
 * La validación real del token (vigencia, usuario correcto) la realiza el resolver.
 */
export const transferenciaTokenGuard: CanActivateFn = (route) => {
  const router   = inject(Router);
  const notify   = inject(NotificationService);

  const token = route.queryParamMap.get('token');

  if (!token || token.trim() === '') {
    notify.warning(
      'Enlace inválido',
      'Para confirmar una transferencia necesitas el enlace enviado por correo electrónico.'
    );
    return router.parseUrl('/inicio');
  }

  return true;
};
